import { CreditCardTransactionResponse } from 'vopay';
import { useEffect, FC, useState } from 'react';
import CreditCardTransactionInfo from './CreditCardTransactionInfo';
import useFetchCreditCardTransaction from '@/hooks/useApi/useFetchCreditCardTransaction';

type CreditCardTransactionContainerProps = {
  TransactionID: string;
  isParent?: boolean;
};

const CreditCardTransactionContainer: FC<CreditCardTransactionContainerProps> = ({
  TransactionID,
  isParent = false,
}) => {
  const [CreditCardTransaction, getCreditCardTransaction] = useFetchCreditCardTransaction({ bearer: '' });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<CreditCardTransactionResponse>();

  useEffect(() => {
    getCreditCardTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (CreditCardTransaction) {
      setTransaction(CreditCardTransaction);
    }
  }, [CreditCardTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <CreditCardTransactionInfo transaction={transaction} isParent={isParent} />}</div>;
};

export default CreditCardTransactionContainer;
